import veritoneApi from '../../../../helpers/veritoneApi';

export const ROOT_FOLDERS_QUERY = `
    {
        rootFolders(type: watchlist) {
            id
            name
            ownerId
            subfolders {
                id
                name
            }
        }
    }
`;

export const CREATE_ROOT_FOLDER_QUERY = `
    mutation {
        createRootFolders(rootFolderType: watchlist) {
            id
            name
            ownerId
            subfolders {
                id
                name
            }
        }
    }
`


export const WATCHLISTS_QUERY = (limit, offset) => `
    {
        watchlists(limit: ${limit}, offset: ${offset}) {
            count
            records {
                id
                name
                folders {
                    id
                }
            }
        }
    }
`;

export const WATCHLIST_QUERY = (id) => `
    {
        watchlist(id: ${id}) {
            id
            folders {
                id
            }
        }
    }
`;


export const CREATE_FOLDER_QUERY = (folder) => `
    mutation {
        createFolder(input: {
                rootFolderType: watchlist,
                name: "${folder.name}",
                description: "${folder.description}",
                parentId: "${folder.parentFolderId}"
            }
        ) {
            id
            name
        }
    }
`;


export const CREATE_WATCHLIST_QUERY = (watchlist) => `
    mutation {
        createWatchlist(input:{
        name: ${watchlist.name},
        stopDateTime: ${watchlist.stopDateTime},
        subscriptions: [],
        cognitiveSearches: [
            {
                mentionStatusId: 1,
                jsonstring: ${watchlist.jsonstring}
            }
        ],
        sourceTypeIds: ["1"],
        parentFolderId : ${watchlist.parentFolderId},
        details: {
            programIds: [${watchlist.stations}]
        },
            searchIndex: global
        }) {
            id
            name
            folders {
                id
            }
        }
    }
`;

export const DELETE_WATCHLIST_QUERY = (id) => `
    mutation {
        deleteWatchlist(id: ${id}) {
            id
        }
    }
`;

export const GET_FOLDER_BY_ID_QUERY = (id) => `
{
    folder(id: "${id}") {
      orderIndex
      treeObjectId
    }
}

`

export const DELETE_FOLDER_QUERY = (id, orderIndex) => `
mutation 
    {
    deleteFolder(input: 
        {
            id: "${id}",
            orderIndex: ${orderIndex}
        }) {
            id
            message
        }
    }
`

export const UPDATE_FOLDER_NAME_QUERY = (id, name) => `
mutation {
    updateFolder(input: {
      id: "${id}"
      name: "${name}"
    }) {
      id
      name
    }
  }
`
async function graphQuery(urlApi, query, variables) {
    let result = {}
    try {
        if (!variables) {
            result = await veritoneApi(urlApi.graphql).post('', { query });
        } else {
            result = await veritoneApi(urlApi.graphql).post('', JSON.stringify({
                query,
                variables
            }))
        }
    } catch (error) {
        return {
            error: true,
            ...error
        }
    }
    const errors = result.data.errors
    if(errors && errors.length) {
        return {
            error: true,
            ...errors
        }
    }
    return result.data;
}

export function createRootFolderApi(urlApi) {
    return graphQuery(urlApi, CREATE_ROOT_FOLDER_QUERY);
}

export function queryFolderApi(urlApi) {
    return graphQuery(urlApi, ROOT_FOLDERS_QUERY);
}

export function queryWatchlistApi(urlApi, limit, offset) {
    return graphQuery(urlApi, WATCHLISTS_QUERY(limit, offset))
}

export function createFolderApi(urlApi, folder) {
    return graphQuery(urlApi, CREATE_FOLDER_QUERY(folder))
}

export function querySingleWatchlistApi(urlApi, id) {
    return graphQuery(urlApi, WATCHLIST_QUERY(id));
}

export function createWatchlistApi(urlApi, watchlist) {
    const mutation = `
      mutation CreateWatchlist($input: CreateWatchlist!) {
        createWatchlist(input: $input) {
            id
            name
            folders {
                id
            }
        }
      }
    `;
    const variables = {
        input: watchlist
    }
    return graphQuery(urlApi, mutation, variables);
}

export function updateWatchlistApi(urlApi, watchlist) {
    const mutation = `
        mutation UpdateWatchlist($input: UpdateWatchlist!) {
            updateWatchlist(input: $input) {
                id
            }
        }
    `;
    const variables = { input: watchlist };
    return graphQuery(urlApi, mutation, variables);
}

export function deleteWatchlistApi(urlApi, id) {
    return graphQuery(urlApi, DELETE_WATCHLIST_QUERY(id));
}

export function getFolderByIdApi(urlApi, id) {
    return graphQuery(urlApi, GET_FOLDER_BY_ID_QUERY(id))
}

export function deleteFolderApi(urlApi, id, orderIndex) {
    return graphQuery(urlApi, DELETE_FOLDER_QUERY(id, orderIndex))
}

export function updateFolderNameApi(urlApi, id, name) {
    return graphQuery(urlApi, UPDATE_FOLDER_NAME_QUERY(id, name))
}